import React, { useEffect, useRef, useState, useLayoutEffect } from "react";
import { useAppSelector, useAppDispatch } from "../../../app/hooks"
import { getHolidaySelectListAsync, resetSelectedRecordObjectInState, updateHolidaysAsync } from "./holidaySelectSlice";
import HolidaySelectItems from "./HolidaySelectItems";
import { ShowSwalWithConfirmation } from '../../../common/SweetAlert';
import { KTIcon } from '../../../_metronic/helpers';
import { ShowToast } from "../../../common/Toastr";
import { useTranslation } from "react-i18next";
import CustomPagination from "../../../common/Pagination";
import Select, { StylesConfig } from 'react-select';
import { useLocation } from 'react-router-dom';
import { updatePageIdState, getPagePermissionsAsync } from '../../../common/GlobalSlice';
import { useNavigate } from 'react-router-dom';
import Loader from '../../../common/Loader';
import PageSizeSelect from '../../../common/PageSizeSelect';
import { getValueFromResource } from "../../../common/timeLiveFunction";
const colourStyles: StylesConfig = {
    control: (styles) => ({ ...styles, backgroundColor: 'white', width: 75, minHeight: '36px', height: '36px', padding: '-1px', borderColor: '#EBECF0', marginRight: '0px', fontWeight: '400px', color: '#172B4F' })
}


const HolidaySelect = () => {

    const dispatch = useAppDispatch();
    const modelRef = useRef<any>(null);
    const { t } = useTranslation();
    const { holidaySelectList, isReload,isLoading, selectedRecord } = useAppSelector((state) => state.holidaySelect);
    const { pageId, menuList, IsList, IsAdd, IsEdit, IsDelete } = useAppSelector((state) => state.globalState);
    const [pageSize, setPageSize] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const location = useLocation();
    const navigate = useNavigate();



    useLayoutEffect(() => {
        const fetchPagePermissions = async () => {
            if (pageId && pageId !== '') {
                const res = await dispatch(getPagePermissionsAsync(pageId));
                if (!res.payload.IsList) {
                    navigate('../error/403');
                }
            } else if (!pageId && menuList && menuList.length > 0) {
                const routeName = location.pathname.split('/').filter(Boolean)[0];
                const foundItem = menuList.find(item => item.SystemCategoryPageFrontEnd === routeName);
                if (foundItem) {
                    const res = await dispatch(getPagePermissionsAsync(foundItem.SystemSecurityCategoryPageId));
                    if (!res.payload.IsList) {
                        navigate('../error/403');
                    }
                } else {
                    navigate('../error/403');
                }
            }
        };

        fetchPagePermissions();
    }, [dispatch, location.pathname, menuList, navigate, pageId]);

    const handlePageChange = (pageNumber: any) => {
        setCurrentPage(pageNumber);
    };
    const handleSearch = (event: any) => {
        const { value } = event.target;
        setSearchTerm(value);
        setCurrentPage(1);
    };

    const handlePageSizeChange = (selectedOption: any) => {
        const { value, label } = selectedOption;
        setPageSize(Number(value));
        setCurrentPage(1);
    };


    const filteredData = holidaySelectList.filter((item: any) =>
        item.HolidayType.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const indexOfLastItem = currentPage * pageSize;
    const indexOfFirstItem = indexOfLastItem - pageSize;
    const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    const totalItems = holidaySelectList.length;
    const recordsFiltered = (totalItems === filteredData.length ? 0 : currentItems.length);
    const options = [{ value: '10', label: '10' }, { value: '20', label: '20' }, { value: '30', label: '30' }, { value: '40', label: '40' }, { value: '50', label: '50' }];

    useEffect(() => {
        if (isReload) {
            dispatch(getHolidaySelectListAsync());
        }

    }, [isReload])

    useEffect(() => {
        dispatch(getHolidaySelectListAsync());
    }, [dispatch])

    const handleOnClickEvent = () => {
        dispatch(updateHolidaysAsync(holidaySelectList))
        .unwrap()
        .then((originalPromiseResult) => {
                ShowToast("Holidays Updated Successfully", 'Success', "success", "toast-top-right");
                dispatch(getHolidaySelectListAsync());
        })
        .catch((rejectedValueOrSerializedError) => {
            ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
        })
    }


    return (
        <>
                   {isLoading && <Loader />}
            <div className="card card-custom admin-card">
                <div className="card-header sticky-top bg-white" style={{ marginLeft: '-10px' }}>
                    <h3 className="card-title fw-bold headerTitle"  >
                        {/* {t('Holidays List')} */}
                        {getValueFromResource('Holidays List',dispatch, t)}

                        </h3>
                    <div className="card-toolbar align-items-center">
                        <div className="position-relative">
                            <input
                                type="text"
                                value={searchTerm}
                                onChange={handleSearch}
                                placeholder=
                                // {t('Search')}
                                {getValueFromResource('Search',dispatch, t)}

                                className="form-control h-35px w-200px fs-7 fw-normal pr-4"
                                data-kt-user-table-filter="search"
                            />
                            <i className="ki-duotone ki-magnifier fs-5 position-absolute top-50 translate-middle-y end-0" style={{ marginRight: '10px' }}>
                                <span className="path1"></span>
                                <span className="path2"></span>
                            </i>
                        </div>
                        <div className='h-35px w-1px mx-1'></div>
                        <div className="d-flex align-items-center">
                            {/* <Select
                                styles={colourStyles}
                                options={options}
                                value={options.find(option => parseInt(option.value) == pageSize)}
                                onChange={handlePageSizeChange}
                                className='fs-7 fw-normal'

                            /> */}
                             <PageSizeSelect onChange={handlePageSizeChange} />

                        </div>
                        {/* <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                        <div>
                            {(currentItems.length > 0) ? (
                                <CustomPagination
                                    currentPage={currentPage}
                                    onPageChange={handlePageChange}
                                    pageSize={pageSize}
                                    totalItems={totalItems}
                                    start={(currentPage - 1) * pageSize}
                                    t={t}
                                >
                                </CustomPagination>
                            ) : null}
                        </div> */}

                        {(currentItems.length > 0) && (
                            <>
                                <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                                <div>
                                    <CustomPagination
                                        currentPage={currentPage}
                                        onPageChange={handlePageChange}
                                        pageSize={pageSize}
                                        totalItems={totalItems}
                                        start={(currentPage - 1) * pageSize}
                                        t={t}
                                    />
                                </div>
                            </>
                        )}
                        {/* {IsEdit && */}
                            <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                        {/* } */}

                        {/* {IsEdit && */}
                            <button ref={modelRef} type="button"
                                className="btn btn-primary  btn-bs-btn-font-weight btn-sm"
                                onClick={handleOnClickEvent}
                            >
                                {/* {t('Update')} */}
                                {getValueFromResource('Update',dispatch, t)}

                            </button>
                        {/* } */}
                    </div>
                </div>
                {IsList &&
                <div className="card-body">
                    <div className="table-responsive">
                        <HolidaySelectItems holidaySelectList={currentItems} t={t} />
                    </div>
                </div>
                 }
            </div>
        </>
    )

}

export default HolidaySelect;